import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NgxSpinnerService } from 'ngx-spinner';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { OcorrenciaTipo } from 'src/app/models/ocorrencia-tipo';
import { OcorrenciaTipoService } from '../../../services/ocorrencia-tipo.service';
import { Setor } from 'src/app/models/setor';
import { SetorService } from 'src/app/services/setor.service';

@Component({
  selector: 'app-cadastrar-ocorrencia-tipo-modal',
  templateUrl: './cadastrar-ocorrencia-tipo-modal.component.html',
  styleUrls: ['./cadastrar-ocorrencia-tipo-modal.component.scss']
})
export class CadastrarOcorrenciaTipoModalComponent implements OnInit {
  idOcorrenciaTipo: number;
  ocorrenciaTipo: OcorrenciaTipo = new OcorrenciaTipo();
  public config: PerfectScrollbarConfigInterface = {};
  editando: boolean;
  carregando: boolean;
  setores: Setor[] = [];
  prioridades = [
    { id: 0, descricao: 'Sem Prioridade', cor: '#6c757d' },
    { id: 1, descricao: 'Baixa', cor: '#198754' },
    { id: 2, descricao: 'Média', cor: '#ffc107' },
    { id: 3, descricao: 'Alta', cor: '#dc3545' }
  ];

  constructor(public dialogRef: MatDialogRef<CadastrarOcorrenciaTipoModalComponent>, private globalService: GlobalService,
    @Inject(MAT_DIALOG_DATA) public data: any, private notificacaoService: NotificacaoService, private setorService: SetorService,
    private spinner: NgxSpinnerService, private utilitarioService: UtilitarioService, private carregandoService: CarregandoService, private ocorrenciaTipoService: OcorrenciaTipoService) {
    this.idOcorrenciaTipo = data.idOcorrenciaTipo;
  }

  ngOnInit(): void {

    this.buscarSetores();

    if (this.idOcorrenciaTipo) {
      this.editando = true;
      this.buscarOcorrenciaTipo();
    } else {
      this.ocorrenciaTipo = new OcorrenciaTipo();
      this.ocorrenciaTipo.prioridade = 0;
    }
  }

  salvar() {
    this.carregandoService.mostra('salvarOcorrenciaTipo');
    this.ocorrenciaTipoService.salvar(this.ocorrenciaTipo).subscribe((retorno) => {
      this.notificacaoService.sucesso('Tipo de ocorrência salva com sucesso!!!');
      this.carregandoService.esconde('salvarOcorrenciaTipo');
      this.dialogRef.close(true);
    }, (erro) => {
      this.carregandoService.esconde('salvarOcorrenciaTipo');
      this.notificacaoService.erro(erro);
    });
  }

  fechar() {
    this.dialogRef.close();
  }

  buscarOcorrenciaTipo() {
    this.carregandoService.mostra('buscarOcorrenciaTipo');

    this.ocorrenciaTipoService.consultarPorId(this.idOcorrenciaTipo).subscribe((data: any) => {
      this.ocorrenciaTipo = data;
      this.carregando = false;
      this.carregandoService.esconde('buscarOcorrenciaTipo');
    }, (erro) => {
      this.carregandoService.esconde('buscarOcorrenciaTipo');
      this.notificacaoService.erro(erro);
    });
  }

  buscarSetores() {
    this.carregandoService.mostra('buscarSetores');

    this.setorService.consultarSetores().subscribe((data: any) => {
      this.setores = data;
      this.carregandoService.esconde('buscarSetores');
    }, (erro) => {
      this.carregandoService.esconde('buscarSetores');
      this.notificacaoService.erro(erro);
    });
  }

  validar() {
    return this.ocorrenciaTipo.descricao !== null && this.ocorrenciaTipo.descricao !== undefined
    && this.ocorrenciaTipo.idSetor !== null && this.ocorrenciaTipo.idSetor !== undefined;
  }

}
